import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles, Box, Typography, ThemeProvider, createMuiTheme, } from '@material-ui/core';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import DateFnsUtils from '@date-io/date-fns';
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { changeRadio, changeNodeGlobalData } from '../redux/actions/tree-action';
import { useSelector, useDispatch } from 'react-redux';
import OneLineTextField from '../CustomizedUIs/CustomTextFiled';

const useStyles = makeStyles(theme => ({
    switch: {
        width: 170,
        height: 30,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        // marginLeft: '24px'
    },
    switchText: {
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '11px',
        letterSpacing: " 0.36px",
        color: "#4f5064",
    },
}));

const materialTheme = createMuiTheme({
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                height: '70px',
                backgroundColor: '#237fc2'
            },
        },
        MuiPickersToolbarText: {
            toolbarTxt: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                color: 'rgba(255, 255, 255, 0.7)',
            },
            toolbarBtnSelected: {
                fontFamily: 'UniviaPro',
                fontSize: '13px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '1.85',
                letterSpacing: ' 0.13px',

            }
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: '#237fc2',
                color: '#ffffff'
            },
        },
        MuiTypography: {
            alignCenter: {
                fontFamily: 'UniviaPro',
                fontSize: '14px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.2,
                letterSpacing: 'normal',
                color: '#4f5064',
            }, colorInherit: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                // color: '#4f5064',
            }
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                color: '#88898c',
            }
        },
        MuiPickersClockNumber: {
            clockNumber: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
            }
        },
        MuiButton: {
            label: {
                fontFamily: 'UniviaPro',
                fontSize: '10px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.4px',

            }
        },
        MuiPickersYear: {
            yearSelected: {
                fontFamily: 'UniviaPro',
                fontSize: '18px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
            },
            root: {
                fontFamily: 'UniviaPro',
                fontSize: '14px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
            }
        },
        MuiInputBase: {
            input: {
                fontFamily: 'UniviaPro',
                fontSize: '13px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '16.3px',
                letterSpacing: '0.13px',
                paddingLeft: '5px'
            }
        }
    },
});
function Radio() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const translate = useTranslate();
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { enableCategories, screenSaverTimeout } = nodeSelected.applicationData.nodeApplication.radio;

    const onToggleEnableCategories = event => {
        onChangeValue('enableCategories')(event.target.checked);
    }

    const onChangeTimeout = (event) => {
        onChangeValue('screenSaverTimeout')(event.target.value);
    }

    const onChangeValue = prop => value => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                radio: {
                    ...nodeSelected.applicationData.nodeApplication.radio,
                    [prop]: value
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    return (
        <Box>
            <Box px={1} className={classes.switch} style={{ marginTop: 25, position: 'relative' }}>
                <Typography className={classes.switchText}>{translate('resources.infoPage.radioItem.enable_categories')}</Typography>
                <GreenSwitch checked={enableCategories} disabled={!isEditing} onChange={onToggleEnableCategories} size='small' style={{ color: 'white' }} />
            </Box>
            <Box mt={3}>
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('resources.infoPage.radioItem.screen_saver_timeout')}
                    value={screenSaverTimeout}
                    type='number'
                    onChange={onChangeTimeout}
                    style={{ width: 500 }}
                />
            </Box>
        </Box>
    )
}

export default Radio;
